import { useResumeRun, useResumeShortfall, useRunCreditPrice } from '../api/hooks';
import { WorkingButton } from './ui/working-button';

/**
 * A failed run's Resume. It is never labeled with a price: the failure returned
 * the run's hold, so the run is still charged once (ruled 2026-09-30). An enrolled
 * account's sends the run's price (`GET credits/runs/:runId`, so the surface needs
 * no run kind), which the resume holds again, and is disabled with the reason
 * beside it when the balance cannot cover that hold.
 */
export function ResumeButton({
  runId,
  resume,
}: {
  runId: string;
  resume: ReturnType<typeof useResumeRun>;
}) {
  const price = useRunCreditPrice(runId, true);
  const short = useResumeShortfall(price.units);
  return (
    <>
      <WorkingButton
        label="Resume"
        workingLabel="Resuming…"
        tiny
        disabled={price.pending || short !== null}
        working={
          resume.isPending &&
          (typeof resume.variables === 'string' ? resume.variables : resume.variables?.runId) ===
            runId
        }
        onClick={() =>
          resume.mutate(
            price.units === undefined ? runId : { runId, expectedCreditUnits: price.units },
          )
        }
      />
      {short ? <span className="credit-short">{short}</span> : null}
    </>
  );
}
